import { combineReducers } from "@reduxjs/toolkit";
import loading from "./loading";

import metamask from "./metamask";
import projectList from "./projectList";
import report from "./report";

const reducer = combineReducers({
	metamask,
	projectList,
	loading,
	report,
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;
